"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
class GlobalMetricReport {
    constructor() {
        this.previousMetrics = {};
        this.currentMetrics = {};
        // As metric values do not necessarily be number, this is a workaround in case metric value is string
        this.currentStringMetrics = {};
    }
}
exports.default = GlobalMetricReport;
//# sourceMappingURL=GlobalMetricReport.js.map